export const numberFormat = (number) =>
  new Intl.NumberFormat('en').format(number);

export const getRandomInt = (min, max) =>
  Math.floor(Math.random() * (max - min + 1) + min);
